
export default {
    /**
     * 保存用户信息
     * @param {*} state
     * @param {*} platId
     */
    setUserInfo(state, userInfo) {
        localStorage.setItem("userInfo", JSON.stringify(userInfo));
        state.userInfo = userInfo;
    },
    /**
     * 保存token信息
     * @param {*} state
     * @param {*} token
     */
    setToken(state, token) {
        localStorage.setItem("token", token);
        state.token = token;
        state.user.token = token;
    },

    webSocketMsg(state, msg) {
      localStorage.setItem("webSocketMsg", msg);
      state.webSocketMsg = msg;
    }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js